export const auction = {
  name: 'Name',
  startDate: 'Date / Time',
  status: 'Status',
  statusOpen: 'Pending'
}
